import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationParents = ({ denominationStructureTypeId }) => {
  return axios.get(`/denominations/${denominationStructureTypeId}/parents`);
};

export const useDenominationParents = ({
  denominationStructureTypeId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denomination-parents", denominationStructureTypeId],
    queryFn: () => getDenominationParents({ denominationStructureTypeId }),
    enabled: !!denominationStructureTypeId
  });
};
